define(
	'actions/announcements',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			pulling: false,
			init: function(params) {
			},
			addAnnouncement: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.CREATE_ANNOUNCEMENT,
					data: params
				});
			},
			pull: function(onComplete) {
				var self = this;
				if(!this.pulling) {
					this.pulling = true;
					var announcements = [];
					window.api.request("announcements").each(function iterator(index, item) {
						announcements.push(item);
					}, function() {
						self.addAnnouncement(announcements)
					});
				}
			},
		});
	}
);
